/* Przewidywana dostawa — liczy dni robocze w czasie warszawskim.
   Reguła przychodzi z atrybutów data-* bloku (ustawienia w edytorze motywu). */
(function () {
  'use strict';

  // „teraz" w Warszawie, zapisane jako lokalna data — klient z Londynu widzi te same terminy co my
  function terazWarszawa() {
    var p = {};
    new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Warsaw', year: 'numeric', month: 'numeric', day: 'numeric',
      hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: false }).formatToParts(new Date())
      .forEach(function (x) { p[x.type] = x.value; });
    return new Date(+p.year, +p.month - 1, +p.day, +p.hour % 24, +p.minute, +p.second);
  }

  function wielkanoc(r) {            // Meeus/Jones/Butcher
    var a = r % 19, b = Math.floor(r / 100), c = r % 100, d = Math.floor(b / 4), e = b % 4,
        f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30,
        i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451),
        mies = Math.floor((h + l - 7 * m + 114) / 31), dz = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(r, mies - 1, dz);
  }
  var cache = {};
  function swieta(r) {
    if (cache[r]) return cache[r];
    var w = wielkanoc(r), plus = function (n) { var d = new Date(w); d.setDate(d.getDate() + n); return d; };
    var lista = [[0, 1], [0, 6], [4, 1], [4, 3], [7, 15], [10, 1], [10, 11], [11, 25], [11, 26]].map(function (md) { return new Date(r, md[0], md[1]); });
    if (r >= 2025) lista.push(new Date(r, 11, 24));           // Wigilia wolna od 2025
    lista.push(w, plus(1), plus(60));                          // Wielkanoc, Poniedziałek Wielkanocny, Boże Ciało
    cache[r] = {}; lista.forEach(function (d) { cache[r][d.toDateString()] = true; });
    return cache[r];
  }
  function klucz(d) { return d.toDateString(); }

  function policz(teraz, R) {
    var wolne = function (d) { return d.getDay() === 0 || d.getDay() === 6 || swieta(d.getFullYear())[klucz(d)] || R.wolne[klucz(d)]; };
    var dodaj = function (d, n, sobotyOk) { var x = new Date(d), k = 0; while (k < n) { x.setDate(x.getDate() + 1); if (!wolne(x) || (sobotyOk && x.getDay() === 6)) k++; } return x; };
    var dzis = new Date(teraz.getFullYear(), teraz.getMonth(), teraz.getDate());
    var przed = !wolne(dzis) && (teraz.getHours() * 60 + teraz.getMinutes()) < R.granicaMin;
    var start = przed ? dzis : dodaj(dzis, 1);
    var od = dodaj(start, R.od, R.soboty), doD = dodaj(start, R.do, R.soboty);
    var gDzien = przed ? dzis : dodaj(dzis, 1);
    var granica = new Date(gDzien.getFullYear(), gDzien.getMonth(), gDzien.getDate(), Math.floor(R.granicaMin / 60), R.granicaMin % 60);
    return { dzis: dzis, przed: przed, od: od, do: doD, granica: granica };
  }

  var DNI = ['ndz', 'pon', 'wt', 'śr', 'czw', 'pt', 'sob'], MIES = ['sty', 'lut', 'mar', 'kwi', 'maj', 'cze', 'lip', 'sie', 'wrz', 'paź', 'lis', 'gru'];
  var fmt = function (d) { return DNI[d.getDay()] + ' ' + d.getDate() + ' ' + MIES[d.getMonth()]; };
  var zakres = function (a, b) {
    if (klucz(a) === klucz(b)) return fmt(a);
    if (a.getMonth() === b.getMonth()) return DNI[a.getDay()] + ' ' + a.getDate() + ' – ' + fmt(b);
    return fmt(a) + ' – ' + fmt(b);
  };
  var godzMin = function (ms) { var m = Math.max(0, Math.floor(ms / 6e4)); return m >= 60 ? Math.floor(m / 60) + ' godz ' + (m % 60 < 10 ? '0' : '') + (m % 60) + ' min' : m + ' min'; };

  function czytajRegule(el) {
    var g = (el.dataset.godzina || '16:00').split(':');
    var wolne = {};
    (el.dataset.wolne || '').split(',').forEach(function (s) {
      s = s.trim(); if (!/^\d{4}-\d{2}-\d{2}$/.test(s)) return;
      var p = s.split('-'); wolne[klucz(new Date(+p[0], +p[1] - 1, +p[2]))] = true;
    });
    return {
      od: Math.max(0, parseInt(el.dataset.od, 10) || 0),
      do: Math.max(0, parseInt(el.dataset.do, 10) || 0),
      granicaMin: (parseInt(g[0], 10) || 0) * 60 + (parseInt(g[1], 10) || 0),
      soboty: el.dataset.soboty === 'true',
      licznik: el.dataset.licznik !== 'false',
      wolne: wolne,
      zdaniePrzed: el.dataset.zdaniePrzed || 'Zamów w ciągu {czas}, a ten termin się utrzyma.',
      zdaniePo: el.dataset.zdaniePo || 'Zamów do {termin}, a ten termin się utrzyma.'
    };
  }

  function uzupelnij(szablon, mapa) {
    return szablon.replace(/\{(czas|termin)\}/g, function (_, k) { return '<b>' + mapa[k] + '</b>'; });
  }

  function start(el) {
    var R = czytajRegule(el);
    var dataEl = el.querySelector('.marami-dostawa__data'), terminEl = el.querySelector('.marami-dostawa__termin');
    var stan;
    function rysuj() {
      var t = terazWarszawa(); stan = policz(t, R);
      dataEl.textContent = zakres(stan.od, stan.do);
      if (stan.przed && R.licznik) {
        terminEl.innerHTML = uzupelnij(R.zdaniePrzed, { czas: godzMin(stan.granica - t) });
      } else {
        var jutro = klucz(stan.granica) === klucz(new Date(stan.dzis.getFullYear(), stan.dzis.getMonth(), stan.dzis.getDate() + 1));
        var gg = stan.granica; var hhmm = gg.getHours() + ':' + (gg.getMinutes() < 10 ? '0' : '') + gg.getMinutes();
        terminEl.innerHTML = uzupelnij(R.zdaniePo, { termin: (jutro ? 'jutro' : DNI[gg.getDay()]) + ' ' + hhmm });
      }
    }
    rysuj();
    // co 30 s odświeżamy licznik; przejście przez godzinę graniczną też łapie ten sam rysuj()
    setInterval(rysuj, 30000);
  }

  function init() { document.querySelectorAll('.marami-dostawa').forEach(function (el) { if (!el.__mdStart) { el.__mdStart = true; start(el); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  // Sleek przeładowuje sekcję produktu przy zmianie wariantu — blok wraca bez stanu
  document.addEventListener('shopify:section:load', init);
})();
